import React from 'react'
import { Box } from '@mui/material'

function HtmlCodeBlock({id, type, properties}) {
  return (
    <Box
      sx={{
        textAlign: properties.align || 'left',
        color: properties.color || '#000000',
        fontSize: properties.fontSize || '16px',
        fontWeight: properties.fontWeight || 'normal',
        padding: `${properties.padding.top}px ${properties.padding.right}px ${properties.padding.bottom}px ${properties.padding.left}px`,
        margin: `${properties.margin.top}px ${properties.margin.right}px ${properties.margin.bottom}px ${properties.margin.left}px`,
        backgroundColor: properties.backgroundColor || 'transparent',
        lineHeight: properties.lineHeight || '1.5',
        whiteSpace: 'pre-wrap',
        // Additional styles for HTML content rendering
        '& *': {
          maxWidth: '100%'
        }
      }}
      dangerouslySetInnerHTML={{
        __html: properties.htmlContent || '<p>Your HTML content here...</p>'
      }}
    />
  )
}

export default HtmlCodeBlock